module.exports = __webpack_public_path__ + "img/location.1c5aec35.svg";